import { FC } from 'react';

import { ImageData } from '../VariationOne';
import {
  SettingsModal as SharedSettingsModal,
  WATERMARK_SECTIONS,
  withWatermarkDefaults,
} from '../shared';

const DIVIDERS = ['none', 'white', 'black'];
export const ACTUAL_PHOTO_VALUES = ['none', 'bottom', 'top'];

interface Props {
  image: ImageData;
  imageIndex: number;
  type: 'left' | 'right';
  onClose: () => void;
  setImages: React.Dispatch<React.SetStateAction<ImageData[]>>;
}

const SettingsModal: FC<Props> = ({ type, image, ...props }) => {
  const RenderTypeText = () => {
    switch (type) {
      case 'left':
        return 'Left';
      case 'right':
        return 'Right';
    }
  };

  return (
    <SharedSettingsModal
      {...props}
      image={withWatermarkDefaults(image)}
      title={`${RenderTypeText()} Image Parameters`}
      sections={[
        ...WATERMARK_SECTIONS,
        {
          title: 'Cover Divider',
          type: 'radio',
          stateKey: 'divider',
          options: DIVIDERS,
          show: type === 'left',
        },
      ]}
    />
  );
};

export default SettingsModal;
